var merge = require('lodash/merge')

const mutations = {
  SET_CURRENT_USER (state, user) {
    state.current_user = user
  },
  UPDATE_CURRENT_USER(state, user) {
    const mergedData = merge(JSON.parse(JSON.stringify(state.current_user)),user)
    state.current_user = mergedData
  },
  SET_NOTIFICATIONS (state, notifications) {
    state.notifications = notifications
  }
}
export default mutations
